export default "__VITE_ASSET__b$HFpDoB__"